<template>
  <div>
    <CommercialIDialCampaign v-if="getShowCommercialICampaign" />
    <CommercialIIDialCampaign v-if="getShowCommercialIICampaign" />
    <CommercialIIIDialCampaign v-if="getShowCommercialIIICampaign" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import CommercialIDialCampaign from "./CommercialIDialCampaign.vue";
import CommercialIIDialCampaign from "./CommercialIIDialCampaign.vue";
import CommercialIIIDialCampaign from "./CommercialIIIDialCampaign.vue";

export default {
  name: "DialCampaign",
  components: {
    CommercialIDialCampaign,
    CommercialIIDialCampaign,
    CommercialIIIDialCampaign,
  },
  computed: {
    ...mapGetters([
      "getShowCommercialICampaign",
      "getShowCommercialIICampaign",
      "getShowCommercialIIICampaign",
    ]),
  },
};
</script>
